<template>
  <div class="c-action-result">
    <div class="c-title">
      <div class="c-text-ad">
        <a href="javascript:;" class="g-pull-right" @click="$emit('on-clear')">清空</a>
        <span>还可添加: &nbsp;{{ length }} 个</span>
      </div>
      <div v-show="subTitle" class="c-extend-ad">
        <span>达人分类：{{ cateLen }}</span>
        <span>抖音达人：{{ wordLen }}</span>
      </div>
    </div>
    <div class="c-content">
      <Spin size="large" fix v-if="!loading" />
      <div class="c-form">
        <div class="c-head">
          <div style="width: 70px"><span>全部</span></div>
          <div style="margin-left: 15px">
            <span>预估覆盖人数</span>
          </div>
          <div style="margin-left: 31px">
            <span>操作</span>
          </div>
        </div>
        <div class="c-body">
          <div class="list-wrap">
            <div class="list-item" v-for="word in value" :key="word.id">
              <span class="name">{{ word.name }}</span>
              <span class="num">{{ word.num }}</span>
              <span class="operate">
                <a href="javascript:;" @click="$emit('on-delete', word)">删除</a>
              </span>
            </div>
          </div>
          <div v-show="!len" class="no-data">
            <Icon type="ios-filing-outline" size="58" color="#efefef" />
            <span>暂未选择</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'actionResult',
  props: {
    value: {
      type: Array
    },
    subTitle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean
    },
    max: {
      type: Number,
      default: 20
    }
  },
  computed: {
    len() {
      return this.value.length
    },
    cateLen() {
      return this.value.filter((ret) => ret.type.toLowerCase() === 'category').length
    },
    wordLen() {
      return this.value.filter((ret) => ret.type.toLowerCase() === 'keyword').length
    },
    length() {
      return this.max - this.len
    }
  }
}
</script>
<style lang="scss" scoped>

.c-action-result {
  min-width: 280px;
  border: solid 1px #dee4f5;

  .c-title {
    height: 50px;
    background-color: #fafbfe;
    padding: 6px 8px;
    color: #999;
    border-bottom: 1px solid #dcdee2;

    .c-text-ad {
      font-size: 14px;
      color: #333;
      line-height: 20px;
      font-weight: 500;
    }

    .c-extend-ad span {
      &:first-child {
        margin-right: 16px;
      }
    }
  }

  .c-content {
    position: relative;

    .c-form {
      .c-head {
        font-size: 14px;
        display: flex;
        padding: 8px 12px;
        font-weight: 500;
        border-bottom: 1px solid #dcdee2;
      }

      .c-body {

overflow-y: auto;
scrollbar-width: thin;
-webkit-overflow-scrolling: touch;

        height: 368px;
        padding: 8px 12px 0;

        .list-item {
          span {
             text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

            display: inline-block;
            line-height: 26px;
          }

          .num {
            width: 66px;
            text-align: right;
          }

          .name {
            width: 102px;
          }

          .operate {
            width: 60px;
            text-align: right;

            a {
              margin-right: 4px;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        .no-data {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          span {
            color: #c1c1c1;
          }
        }
      }
    }
  }
}
</style>
